import { gql } from "@apollo/client";

export const MODIFY_BLACK_LIST = gql`
  mutation (
    $id: Int!
    $phone: String!
    $type: Int!
    $locked_at: Int!
    $comment: String
    $files: String
  ) {
    modifyBlackList(
      id: $id
      phone: $phone
      type: $type
      locked_at: $locked_at
      comment: $comment
      files: $files
    )
  }
`;

export const UNLOCK_BLACK_LIST = gql`
  mutation ($id: Int!) {
    unlockBlackList(id: $id) {
      id
      phone
      user_id
      type(asText: true)
      locked_at
      comment
      status
    }
  }
`;
